import React from 'react';

function Hint({ dir, text, hintImg, number, level, onClick }) {
  let content;
  const _text = text.replace('$dir/', dir);
  if (!hintImg) {
    content = (
      <div className="questionTxtInner txtLg">
        <div dangerouslySetInnerHTML={{ __html: _text }} />
      </div>
    );
  } else {
    content = (
      <div className="questionTxtInner useIllust">
        <div className="questionHintImage">
          <img src={dir + 'assets/img/illust/' + Number(level + 1) + '/illust-' + Number(number + 1) + '-hint.png'} alt="" />
        </div>
        <div className="questionTxtRight">
          <div dangerouslySetInnerHTML={{ __html: _text }} />
        </div>
      </div>
    );
  }
  return (
    <div className={'questionContent questionUseMinDoctor questionHint ' + 'questionHint-number-' + Number(level + 1) + '-' + Number(number + 1)}>
      <div className="questionTxt">
        <div className="questionPageTitle quistionPageTitleHint">
          <img src={dir + 'assets/img/ttl-hint.png'} alt="ヒント" />
        </div>
        {content}
        <button
          onTouchStart={() => {}}
          className="questionBtn questionBackBtn"
          onClick={() => {
            onClick(1);
          }}
        >
          <img src={dir + 'assets/img/btn-back.png'} alt="謎へ戻る" />
        </button>
      </div>
    </div>
  );
}
export default Hint;
